import React, { useState } from "react";

const CartItems = () => {
    const [selectedItems, setSelectedItems] = useState([]);
    const items = [
        { id: 1, name: "Item A", price: 10 },
        { id: 2, name: "Item B", price: 15 },
        { id: 3, name: "Item C", price: 20 },
        { id: 4, name: "Item D", price: 25 },
    ];

    const handleCheckboxChange = (item) => {
        if (selectedItems.includes(item)) {
            setSelectedItems(selectedItems.filter((i) => i !== item));
        } else {
            setSelectedItems([...selectedItems, item]);
        }
    };

    const calculateTotalPrice = () => {
        return selectedItems.reduce((total, item) => total + item.price, 0);
    };

    return (
        <div className="registration-card">
            <h2>Register for Items</h2>
            <ul>
                {items.map((item) => (
                    <li key={item.id}>
                        <label>
                            <input
                                type="checkbox"
                                checked={selectedItems.includes(item)}
                                onChange={() => handleCheckboxChange(item)}
                            />
                            {item.name} - ${item.price}
                        </label>
                    </li>
                ))}
            </ul>
            <h3>Total Price: ${calculateTotalPrice()}</h3>
            <button>Submit Registration</button>
        </div>
    );
};

export default CartItems;
